import { computed, ref } from 'vue'

export const theme = ref(localStorage.getItem('theme') || 'default')

export const VALID_THEMES = [
  'default',
  'happy-light',
  'happy-dark',
  // 'noct': 'nocturne',
  'happy-urban-dark-red',
  'happy-urban-light-red',
  'happy-orange-light',
  'happy-orange-dark',
  'happy-fresh-mint',
  'happy-bee-light',
  'happy-bee-dark',
  'happy-earth-stone',
  'happy-scorched-earth',
  'happy-sand-sky',
  'happy-gray-sand',
  'happy-purple-gradient',
  'happy-ifo-dark',
  'happy-ifo-light'
]

export const VALID_THEMES_HAPPY = [
  'happy-light',
  'happy-dark',
]



export const applyTheme = (newTheme: string) => {
  if (!VALID_THEMES.includes(newTheme)) {
    newTheme = 'default'
  }

  document.documentElement.classList.remove(...VALID_THEMES)
  document.documentElement.classList.add(newTheme)
  theme.value = newTheme
  localStorage.setItem('theme', newTheme)
}



export const isThemeDefault = computed(() => theme.value === 'default')
export const isThemeHappy = computed(() => theme.value === 'happy-dark' || theme.value === 'happy-light' ? true : false)

export const isThemeNoct = computed(() => theme.value === 'nocturne')

export const isThemeUrbanDarkRed = computed(() => theme.value === 'happy-urban-dark-red')
export const isThemeUrbanLightRed = computed(() => theme.value === 'happy-urban-light-red')
export const isThemeOrangeLight = computed(() => theme.value === 'happy-orange-light')
export const isThemeOrangeDark = computed(() => theme.value === 'happy-orange-dark')
export const isThemeFreshMint = computed(() => theme.value === 'happy-fresh-mint')
export const isThemeBeeLight = computed(() => theme.value === 'happy-bee-light')
export const isThemeBeeDark = computed(() => theme.value === 'happy-bee-dark')
export const isThemeEarthStone = computed(() => theme.value === 'happy-earth-stone')
export const isThemeScorchedEarth = computed(() => theme.value === 'happy-scorched-earth')
export const isThemeSandSky = computed(() => theme.value === 'happy-sand-sky')
export const isThemeGraySand = computed(() => theme.value === 'happy-gray-sand')
export const isThemePurpleGradient = computed(() => theme.value === 'happy-purple-gradient')
export const isThemeIfoDark = computed(() => theme.value === 'happy-ifo-dark')
export const isThemeIfoLight = computed(() => theme.value === 'happy-ifo-light')
// True for either ifo variant — use this when behaviour should be shared
// across the ifo family (ember effects, glass header, minimalist auth pages).
export const isThemeIfoFamily = computed(() => isThemeIfoDark.value || isThemeIfoLight.value)


export const isOtherThemeHappy = computed(() => {
  if (isThemeUrbanDarkRed.value ||
    isThemeUrbanLightRed.value ||
    isThemeOrangeLight.value ||
    isThemeOrangeDark.value ||
    isThemeFreshMint.value ||
    isThemeBeeLight.value ||
    isThemeBeeDark.value ||
    isThemeEarthStone.value ||
    isThemeScorchedEarth.value ||
    isThemeSandSky.value ||
    isThemeGraySand.value ||
    isThemePurpleGradient.value ||
    isThemeIfoDark.value ||
    isThemeIfoLight.value) {
    return true
  }
  return false
})